import React from "react";
import "../../../css/table.css";
import ReactTable from "react-table";
import { connect } from "react-redux";
import { toArray, orderBy } from "lodash";
import LineForm from "../../../forms/LineForm.jsx";
import Modal from "../../../components/Modal/Modal.jsx";
import { db } from "../../../services/firebase";
import { resetForm } from "../../../ducks/Forms";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationSystem from "react-notification-system";
import Button from "../../../elements/CustomButton/CustomButton.jsx";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import SweetSpinner from "../../../components/SweetSpinner/SweetSpinner.jsx";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import { style as NotifyStyle } from "../../../variables/Variables.jsx";
import { faPencilAlt, faTrash } from "@fortawesome/fontawesome-free-solid";

class Lines extends React.Component {
  constructor(props) {
    super(props);
    this.companyID = props.companyID;

    this.state = {
      fetchingLines: true,
      lineModal: false,
      targetLine: null,
      lines: {},
      alert: null,
      _notificationSystem: null,
    };
  }

  componentDidMount() {
    this._fetchLines();
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  render() {
    return (
      <div>
        {this.state.alert}
        {this.lineModal()}
        <NotificationSystem ref="notificationSystem" style={NotifyStyle} />
        <Row>
          <Col md={12}>
            <Button
              bsStyle="default"
              wd
              className="pull-right"
              style={{ marginBottom: 10 }}
              onClick={() => {
                this.props.resetForm("LineForm");
                this.setState({ lineModal: true, targetLine: null });
              }}
            >
              Adicionar Linha
            </Button>
          </Col>
        </Row>
        {this._renderLinesTable(this.state.lines)}
      </div>
    );
  }

  _fetchLines = () => {
    const { companyID } = this.props;
    this.setState({ fetchingLines: true });
    db.collection("companies")
      .doc(companyID)
      .collection("lines")
      .onSnapshot((lineSnapshot) => {
        if (!lineSnapshot.empty) {
          const lines = [];
          lineSnapshot.forEach((line) =>
            lines.push({ ...line.data(), id: line.id })
          );
          this.setState({ fetchingLines: false, lines });
        } else {
          this.setState({ fetchingLines: false });
        }
      });
  };

  _setLine = (values) => {
    this.setState({ lineModal: false });
    this.waitAlert("Salvando dados", true);
    const { companyID } = this.props;
    db.collection("companies")
      .doc(companyID)
      .collection("lines")
      .add({ name: values.name, places: values.places.value })
      .then(() => {
        this.hideAlert();
        this.notify("Linha adicionada", "success");
      })
      .catch((e) => {
        this.hideAlert();
        console.log(e);
        this.notify("Erro ao adicionar linha", "error");
      });
  };

  _updateLine = (lineID) => (values) => {
    this.setState({ lineModal: false });
    this.waitAlert("Atualizando dados", true);
    const { companyID } = this.props;
    db.collection("companies")
      .doc(companyID)
      .collection("lines")
      .doc(lineID)
      .update({ name: values.name, places: values.places })
      .then(() => {
        this.hideAlert();
        this.notify("Linha atualizada", "success");
        console.log(values.places);
      })
      .catch((e) => {
        this.hideAlert();
        console.log(e);
        this.notify("Erro ao atualizar linha", "error");
      });
  };

  _remove = (id) => {
    this.hideAlert();
    this.waitAlert("Validando dados, aguarde", false);

    const { companyID } = this.props;

    db.collection("companies")
      .doc(companyID)
      .collection("results")
      .where("line", "==", id)
      .get()
      .then((snap) => {
        if (snap.empty) {
          this.hideAlert();
          this.waitAlert("Removendo, aguarde", false);
          db.collection("companies")
            .doc(companyID)
            .collection("places")
            .doc(id)
            .delete()
            .then(() => {
              this.hideAlert();
              this.notify("Linha removida", "success");
            })
            .catch((e) => {
              this.hideAlert();
              this.notify("Erro ao remover linha", "error");
            });
        } else {
          this.hideAlert();
          this.notify(
            "Esta linha possui ligações com os dados da empresa e não pode ser removida.",
            "warning"
          );
        }
      });
  };

  lineModal = () => {
    const { targetLine } = this.state;
    return (
      <Modal
        title={targetLine ? "Atualizar linha" : "Adicionar linha"}
        isOpen={this.state.lineModal}
        content={
          <LineForm
            initialValues={targetLine}
            companyID={this.props.companyID}
            onSubmit={(values) => {
              targetLine
                ? this._updateLine(targetLine.id)(values)
                : this._setLine(values);
            }}
            handleCancel={() =>
              this.setState({ lineModal: false, targetLine: null })
            }
          />
        }
      />
    );
  };

  _renderLinesTable = (data) => (
    <ReactTable
      columns={[
        { Header: "Nome", accessor: "name" },
        {
          Header: "Ações",
          accessor: "",
          Cell: ({ value }) => (
            <div style={{ textAlign: "center" }}>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`edit_${value.id}`}>Editar</Tooltip>}
              >
                <a
                  className="btn btn-simple btn-default btn-icon"
                  onClick={() =>
                    this.setState({ targetLine: value, lineModal: true })
                  }
                >
                  <FontAwesomeIcon className="text-dark" icon={faPencilAlt} />
                </a>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id={`remove_${value.id}`}>Remover</Tooltip>}
              >
                <a
                  className="btn btn-simple btn-danger btn-icon"
                  onClick={() => this.removeAlert(value.id)}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </a>
              </OverlayTrigger>
            </div>
          ),
        },
      ]}
      data={orderBy(toArray(data), ["name", "asc"])}
      onFetchData={this._fetchLines}
      loading={this.state.fetchingLines}
      defaultPageSize={10}
      className="-striped -highlight"
      previousText="Anterior"
      nextText="Próximo"
      loadingText="Carregando"
      noDataText="Nenhuma linha encontrada"
      pageText="Página"
      ofText="de"
      rowsText="Registros"
    />
  );

  //Notifications
  notify = (message, level) => {
    this.state._notificationSystem.addNotification({
      title: null,
      message: <b>{message}</b>,
      level,
      position: "tr",
      autoDismiss: 4,
    });
  };

  //SweetAlerts
  hideAlert = () => this.setState({ alert: null });

  removeAlert = (id) => {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block" }}
          title="Tem certeza?"
          onConfirm={() => this._remove(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="default"
          cancelBtnBsStyle="warning"
          confirmBtnText="Continuar"
          cancelBtnText="Cancelar"
          showCancel
        />
      ),
    });
  };

  waitAlert = (title, showSpinner) => {
    this.setState({
      alert: (
        <SweetAlert
          style={{ display: "block" }}
          title={title}
          onConfirm={() => null}
          showConfirm={false}
        >
          {showSpinner ? <SweetSpinner /> : null}
        </SweetAlert>
      ),
    });
  };
}

export default connect(null, { resetForm })(Lines);



// WEBPACK FOOTER //
// ./src/views/Companies/Tabs/Lines.jsx